export enum StickyType {
  DEFAULT = 'default',
  SLIDER = 'slider'
}

export enum StickyVariant {
  OTHER_VAR = 'other-var'
}
